import { render, staticRenderFns } from "./physicalcarddetail.vue?vue&type=template&id=c75d15a0&scoped=true"
import script from "./physicalcarddetail.vue?vue&type=script&lang=js"
export * from "./physicalcarddetail.vue?vue&type=script&lang=js"
import style0 from "./physicalcarddetail.vue?vue&type=style&index=0&id=c75d15a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75d15a0",
  null
  
)

export default component.exports